import React from 'react';
import { Box, Button, Typography, styled } from '@mui/material';
import { Link } from 'react-router-dom';

const CallToAction = () => {
    const StyledBox = styled(Box)(({ theme }) => ({
        background: '#c1c5c6', // Degradado de tonos de la paleta
        padding: theme.spacing(5),
        borderRadius: '16px',
        textAlign: 'center',
        margin: theme.spacing(3, 0),
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    }));

    return (
        <StyledBox>
            <Typography
                variant="h4"
                sx={{
                    fontWeight: 'bold',
                    marginBottom: 2,
                    color: '#20232A', // Color de texto principal
                }}
            >
                Notas{' '}
                <span style={{ color: '#718895' }}>Informativas</span>
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: '#4D5C61', // Color de texto secundario
                    marginBottom: 3,
                    lineHeight: 1.6,
                }}
            >
                Descubre lo nuevo que tenemos para tí
            </Typography>
            <Button
                component={Link}
                to="/notas-informativas"
                variant="contained"
                sx={{
                    px: { xs: 3, md: 4 }, // Padding horizontal responsivo
                    py: { xs: 1, md: 1.5 }, // Padding vertical responsivo
                    fontSize: { xs: '0.9rem', md: '1rem' }, // Tamaño de fuente responsivo
                    fontWeight: 600,
                    color: '#fff', // Color de texto
                    backgroundColor: 'rgb(51, 64, 64)', // Color de fondo
                    borderRadius: '10px', // Bordes redondeados
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Sombra del botón
                    transition: 'all 0.3s ease', // Transición suave
                    '&:hover': {
                        backgroundColor: 'rgb(41, 54, 54)', // Fondo al hacer hover
                        transform: 'scale(1.05)', // Escala al hacer hover
                        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)', // Sombra al hacer hover
                    },
                }}
            >
                Descubrir
            </Button>
        </StyledBox>
    );
};

export default CallToAction;
